"use client";

import { ErrorNotice, Notice } from "@/components/tool-kit/primitives";
import {
  BUTTON_PRIMARY,
  CARD,
  HINT,
  INPUT_MONO,
  LABEL,
} from "@/components/tool-kit/styles";

/**
 * An identifier box with a "Look up" button and a status line — the optional first
 * step of the clinical-trial and GitHub generators. Every word comes from the calling
 * widget's strings. Enter in the box runs the lookup, as the button does.
 */
export function LookupRow({
  id,
  label,
  placeholder,
  hint,
  buttonLabel,
  loadingLabel,
  value,
  onChange,
  onLookup,
  loading,
  message,
  error,
}: {
  id: string;
  label: string;
  placeholder: string;
  hint: string;
  buttonLabel: string;
  loadingLabel: string;
  value: string;
  onChange: (value: string) => void;
  onLookup: () => void;
  loading: boolean;
  /** A success or guidance line under the box. */
  message: string;
  /** A failed lookup, shown as an alert. */
  error: string;
}) {
  return (
    <div className={`${CARD} space-y-3`}>
      <label className={LABEL} htmlFor={id}>
        {label}
      </label>
      <div className="flex flex-col gap-2 sm:flex-row">
        <input
          autoComplete="off"
          className={INPUT_MONO}
          id={id}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              onLookup();
            }
          }}
          placeholder={placeholder}
          spellCheck={false}
          type="text"
          value={value}
        />
        <button
          className={`${BUTTON_PRIMARY} shrink-0`}
          disabled={loading || value.trim() === ""}
          onClick={onLookup}
          type="button"
        >
          {loading ? loadingLabel : buttonLabel}
        </button>
      </div>
      <p className={HINT}>{hint}</p>
      {error ? <ErrorNotice>{error}</ErrorNotice> : null}
      {message && !error ? <Notice>{message}</Notice> : null}
    </div>
  );
}
